import React from 'react';
import { Slider } from 'antd';
import { CommonSliderProps } from 'types';
import { ButtonCommon } from '../Button/ButtonCommon';
interface CommonSliderPropsExtended extends CommonSliderProps {
  onApply?: () => void;
  onReset?: () => void;
  showButtons?: boolean;
}

const CommonSlider: React.FC<CommonSliderPropsExtended> = ({
  title = 'Khoảng giá',
  value,
  onChange,
  min = 0,
  max = 100,
  disabled = false,
  onApply,
  onReset,
  showButtons = true,
}) => {
  const handleReset = () => {
    onReset?.();
  };

  const handleApply = () => {
    onApply?.();
  };

  return (
    <div className='px-6 py-3 bg-white rounded-lg w-full'>
      <p className='text-[14px] leading-[20px] font-medium text-black mb-2'>{title}</p>

      <Slider
        range
        min={min}
        max={max}
        value={value}
        onChange={(val) => onChange(val as [number, number])}
        disabled={disabled}
        className='my-2'
      />
      <div className='text-xs text-[var(--primaryColor500)] mb-3 flex justify-between'>
        <span>
          {value?.[0]?.toLocaleString()} <span className='text-[var(--primaryColor300)]'>VND</span>
        </span>
        <span>
          {value?.[1]?.toLocaleString()} <span className='text-[var(--primaryColor300)]'>VND</span>
        </span>
      </div>
      {showButtons && (
        <div className='flex justify-end gap-6'>
          <ButtonCommon color='barcode' className='text-black' radius='rounded' size='xs' onClick={handleReset}>
            Xóa
          </ButtonCommon>
          <ButtonCommon
            color='basic'
            className='bg-[var(--primaryColor500)] px-3 gap-2'
            radius='rounded'
            onClick={handleApply}
          >
            Áp dụng
          </ButtonCommon>
        </div>
      )}
    </div>
  );
};

export default CommonSlider;
